import containerFuild from '../html-snippets/container-fuild.js';
import buttonPrimary from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-fastvaluedeal-countdown';

const buttonPrimaryHtml = buttonPrimary({
  text: 'GET 80% DISCOUNT',
  backgroundColor: '#17BE4F',
  radius: 8,
  iconPrefix: {
    show: false,
    src: '',
  },
  iconSuffix: {
    show: false,
    src: '',
  },
  subBtn: {
    show: false,
    text: '',
  },
});

const html = ` 
<div
  class="fvd-countdown-content container"
  data-attribute="fvd-countdown-content"
  data-image-position="left"
  data-image-show="true"
>
  <div class="fvd-countdown__image" data-attribute="fvd-countdown__image">
    <img
      data-attribute="fvd-countdown__image-img"
      src="https://cdn.skyfastimg.com/images/2026/06/02/image-6a1e60e05920e381ffc25d09.png?w=500&h=50&q=80"
      alt="img"
    />
  </div>
  <div class="fvd-countdown__info" data-attribute="fvd-countdown__info">
    <div class="fvd-countdown__title" data-attribute="fvd-countdown__title">
      <h2 style="text-align: center">
        <strong>Limited Time Offer: 80% OFF WaveMax</strong>
      </h2>
      <p style="text-align: center">
        Get Your WaveMax Before This Special Offer Ends!
      </p>
    </div>
    <div class="fvd-countdown__policy" data-attribute="fvd-countdown__policy">
      <div
        class="fvd-countdown__policy-item"
        data-attribute="fvd-countdown__policy-item"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M17 14h.01" />
          <path
            d="M7 7h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14"
          />
        </svg>
        <p
          class="fvd-countdown__policy-item-money-back"
          data-attribute="fvd-countdown__policy-item-money-back"
        >
          30-DAY MONEY-BACK
        </p>
      </div>
      <div
        class="fvd-countdown__policy-item"
        data-attribute="fvd-countdown__policy-item"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M13 6v5a1 1 0 0 0 1 1h6.102a1 1 0 0 1 .712.298l.898.91a1 1 0 0 1 .288.702V17a1 1 0 0 1-1 1h-3"
          />
          <path
            d="M5 18H3a1 1 0 0 1-1-1V8a2 2 0 0 1 2-2h12c1.1 0 2.1.8 2.4 1.8l1.176 4.2"
          />
          <path d="M9 18h5" />
          <circle cx="16" cy="18" r="2" />
          <circle cx="7" cy="18" r="2" />
        </svg>
        <p
          class="fvd-countdown__policy-item-fast-shipping"
          data-attribute="fvd-countdown__policy-item-fast-shipping"
        >
          FAST SHIPPING
        </p>
      </div>
      <div
        class="fvd-countdown__policy-item"
        data-attribute="fvd-countdown__policy-item"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M16 10a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 14.286V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
          />
          <path
            d="M20 9a2 2 0 0 1 2 2v10.286a.71.71 0 0 1-1.212.502l-2.202-2.202A2 2 0 0 0 17.172 19H10a2 2 0 0 1-2-2v-1"
          />
        </svg>
        <p
          class="fvd-countdown__policy-item-support"
          data-attribute="fvd-countdown__policy-item-support"
        >
          24/7 SUPPORT
        </p>
      </div>
    </div>
    <div class="fvd-countdown__timer" data-attribute="fvd-countdown__timer">
      <div class="fvd-countdown__rating" data-attribute="fvd-countdown__rating">
        <img
          data-attribute="fvd-countdown__rating-img"
          src="https://cdn.skyfastimg.com/images/2026/06/02/image-6a1e60f63d596a81b7a48556.jpg"
          alt="rating"
        />
      </div>
      <div
        class="fvd-countdown__timer-countdown"
        data-attribute="fvd-countdown__timer-countdown"
      >
        <p
          class="fvd-countdown__timer-countdown-text"
          data-attribute="fvd-countdown__timer-countdown-text"
        >
          Ending Soon:
        </p>
        <p
          class="fvd-countdown__timer-countdown-time"
          data-attribute="fvd-countdown__timer-countdown-time"
          data-time="10"
        >
          10:00
        </p>
      </div>
    </div>
    ${buttonPrimaryHtml}
  </div>
</div>
`;

export default containerFuild(html, css, {
  backgroundImage: 'https://cdn.skyfastimg.com/images/2026/06/02/image-6a1e610d522beb73c066e7b2.jpg?w=1000&h=50&q=80',
});
